var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "root",
      class: {
        internal: _vm.value.isInternal,
        interraction: _vm.value.isInterraction,
        own: _vm.isFromCurrentUser,
        owner: _vm.isFromOwner,
        attention: _vm.currentUserHasAttention,
      },
    },
    [
      !_vm.value.isInterraction
        ? _c(
            "div",
            { staticClass: "msg" },
            [
              _vm.updating
                ? _c(
                    "div",
                    { staticClass: "text-box" },
                    [
                      _c("w-textarea-autogrow", {
                        staticClass: "textarea",
                        attrs: {
                          placeholder: "message",
                          "max-height": 400,
                          autofocus: "",
                          value: _vm.updatedContent,
                        },
                        on: {
                          input: function ($event) {
                            _vm.updatedContent = $event
                          },
                          keyup: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              if (!$event.ctrlKey) return null
                              if (
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              )
                                return null
                              _vm.updatedContent += "\n"
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape",
                                ])
                              )
                                return null
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              )
                                return null
                              return _vm.stopUpdatingMessage()
                            },
                          ],
                        },
                      }),
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "", lg: "" },
                          on: {
                            click: function ($event) {
                              return _vm.updateMessage()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            staticClass: "fa-rotate-90",
                            attrs: { icon: "level-down-alt" },
                          }),
                          _vm._v(" Opslaan "),
                        ],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "", lg: "" },
                          on: {
                            click: function ($event) {
                              return _vm.stopUpdatingMessage()
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "times-circle" } }),
                          _vm._v(" Annuleer "),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { attrs: { "no-margin": "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        style: { flexGrow: 0, width: "auto", flexShrink: 1 },
                        attrs: { "no-margin": "" },
                      },
                      [
                        _c(
                          "w-row",
                          { staticClass: "time-and-name" },
                          [
                            _vm.profileImage
                              ? _c("div", {
                                  staticClass: "icon profile",
                                  style: { backgroundImage: _vm.profileImage },
                                })
                              : _vm._e(),
                            _vm._v(
                              _vm._s(_vm.value.getFirstName()) +
                                ", " +
                                _vm._s(_vm.timestamp(_vm.value.timeCreated)) +
                                " "
                            ),
                            _vm.value.isInternal
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "internal-title",
                                    class: {
                                      internal: _vm.value.isInternal,
                                      own: _vm.isFromCurrentUser,
                                    },
                                  },
                                  [_vm._v(" Interne boodschap ")]
                                )
                              : _vm._e(),
                            _c("w-spacer"),
                            _c(
                              "div",
                              { staticClass: "msg-actions" },
                              [
                                _vm.value.adminId != 0
                                  ? _c(
                                      "w-button",
                                      {
                                        attrs: { flat: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.replyClicked()
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "reply" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "w-dropdown",
                                  {
                                    attrs: { items: _vm.actionList, flat: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.triggerAction($event)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(" Menu "),
                                    _c("w-fa", {
                                      attrs: { icon: "chevron-down" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("app-message-like-button", {
                              style: { margin: "0 10px" },
                              attrs: { ticket: _vm.ticket, message: _vm.value },
                            }),
                          ],
                          1
                        ),
                        _c("w-row", [
                          _vm.title
                            ? _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(_vm.title)),
                              ])
                            : _vm._e(),
                          _c("pre", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.content,
                                expression: "content",
                              },
                            ],
                          }),
                        ]),
                        _c(
                          "w-row",
                          _vm._l(
                            _vm.value.attachements,
                            function (attachement, i) {
                              return _c("app-attachement", {
                                key: i,
                                attrs: { value: attachement },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
              _vm.hasAttentions
                ? _c(
                    "w-row",
                    { staticClass: "attentions" },
                    [
                      _vm.hasAttentions
                        ? _c("app-attentions", {
                            attrs: { value: _vm.value.attentions },
                            on: {
                              "toggle-as-read": function ($event) {
                                return _vm.toggleAsRead($event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm.currentUserHasAttention
                        ? _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.markDepartementAsReadToolTip,
                                  expression: "markDepartementAsReadToolTip",
                                },
                              ],
                              staticClass: "attentions-button",
                              attrs: { flat: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showRemoveDepartementAttentions = true
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "edit" } })],
                            1
                          )
                        : _vm._e(),
                      _c("w-spacer"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.value.isInterraction
        ? _c("div", { staticClass: "msg" }, [
            _c("b", [_vm._v(_vm._s(_vm.value.getFirstName()))]),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: _vm.content,
                  expression: "content",
                },
              ],
            }),
            _vm._v(" op "),
            _c("b", [_vm._v(_vm._s(_vm.timestamp(_vm.value.timeCreated)))]),
          ])
        : _vm._e(),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showRemoveDepartementAttentions,
            callback: function ($$v) {
              _vm.showRemoveDepartementAttentions = $$v
            },
            expression: "showRemoveDepartementAttentions",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "700" } },
            [
              _c("w-card-title", [_vm._v("Opgelet!")]),
              _c("w-card-content", [
                _c("p", { staticClass: "departmentAttentionWarningText" }, [
                  _vm._v(
                    " " + _vm._s(_vm.removeDepartementAttentionsText) + " "
                  ),
                ]),
              ]),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showRemoveDepartementAttentions = false
                        },
                      },
                    },
                    [_vm._v(" Neen ")]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.markDepartementAsRead()
                        },
                      },
                    },
                    [_vm._v(" Ja ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }